import { Injectable } from '@angular/core';

import { ActiveToast, IndividualConfig, Toast, ToastrService } from 'ngx-toastr';

import {
    DEFAULT_ERROR_TOAST_TIMEOUT,
    DEFAULT_TOAST_TIMEOUT,
    DEFAULT_WARNING_TOAST_TIMEOUT,
} from '@config/global-constants';

/**
 * Adapter for notification library
 */
@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private readonly toastr: ToastrService) {}

    success<T = Toast>(message: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<T> {
        const defaultConfig: Partial<IndividualConfig> = {
            timeOut: DEFAULT_TOAST_TIMEOUT,
        };
        const customConfig = { ...defaultConfig, ...override };
        return this.toastr.success(message, title, customConfig);
    }

    error<T = Toast>(message: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<T> {
        const defaultConfig: Partial<IndividualConfig> = {
            timeOut: DEFAULT_ERROR_TOAST_TIMEOUT,
        };
        const customConfig = { ...defaultConfig, ...override };
        return this.toastr.error(message, title, customConfig);
    }

    info<T = Toast>(message: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<T> {
        return this.toastr.info(message, title, override);
    }

    warning<T = Toast>(message: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<T> {
        const defaultConfig: Partial<IndividualConfig> = {
            timeOut: DEFAULT_WARNING_TOAST_TIMEOUT,
            closeButton: true,
        };
        const customConfig = { ...defaultConfig, ...override };
        return this.toastr.warning(message, title, customConfig);
    }

    clear(toastId?: number): void {
        this.toastr.clear(toastId);
    }
}
